module.exports = __webpack_public_path__ + "img/product-reviews-06.0efd093a.png";